/**
 * @module cartridge/js/showLoading
 */

'use strict';

var $ = require('jquery');
var progress = require('./progress');
var listener = require('./addListener');
var util = require('./util');

/**
 * @function
 * @description adds listener to form when submitted and shows loading spinner
 * @param formToSubmitId
 * @param buttonId
 */

exports.showLoading = function (formToSubmit, button) {
    //exclude InternetExplorer due to unsupported ES6 features
    if (util.isInternetExplorer()) {
        return false;
    }

    if ($('html').hasClass('ios')) {
        listener.listen(button, 'touchstart').then(function () {
            if ($(formToSubmit).valid()) {
                progress.show('#primary');
                $(button).trigger('click');
            }
        });
    } else {
        listener.listen(button, 'click').then(function () {
            if ($(formToSubmit).valid()) {
                progress.show('#primary');
            }
        });
    }
};
